import styled from 'styled-components';
import HappyLikeStarSvg from './happyLikeStar.svg';

const HappyLikeStarIcon = styled(HappyLikeStarSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || '#46484D'};
`;
export default HappyLikeStarIcon;
